<template>
<base-modal :modalSize="'small'" v-bind:modalTitle="'Edit Expression'" v-on:save="save()" v-on:close="close()">
    <FormulateForm @validation="validation">
        <FormulateInput label="Type" type="select" :options="expressionTypeOptions" v-model="model.expression_type" validation="required" @input="hasErrors = false" />
        <FormulateInput label="Negate" type="checkbox" v-model="model.negate" />
        <template v-if="model.expression_type == 'rule'">
          <FormulateInput type="select" :options="fieldOptions" v-model="model.field" label="Field" validation="required" />
          <FormulateInput type="radio" :options="opOptions" v-model="model.operator" />
          <FormulateInput v-if="valuesOptions && currentOp && currentOp.arity == 2" type="select" :options="valuesOptions" v-model="model.values" label="Value(s)" validation="required" />
          <FormulateInput v-else-if="valuesOptions && currentOp && currentOp.arity == 'n'"
                          type="checkbox"
                          :wrapper-class="['multiple-choices']"
                          :options="valuesOptions"
                          v-model.lazy="model.values" label="Value(s)" validation="required" />
          <FormulateInput v-else-if="currentOp && currentOp.arity == 2" type="text" v-model.lazy="model.values" label="Value" validation="required" />
          <FormulateInput v-else-if="currentOp && currentOp.arity == 'n'" type="text" v-model.lazy="model.values" label="Value(s)" help="Use a comma to separate values" validation="required" />
      </template>
      <template v-if="expression">
          <h4>Advanced</h4>
          <FormulateInput type="button" @click="deleteExpression"><i class="fa fa-trash"></i>&nbsp;Delete</FormulateInput>
      </template>
  </FormulateForm>
</base-modal>
</template>

<script>
 // Load the full build. 
 var _ = require('lodash');

 import BaseModal from 'components/modals/BaseModal';

 export default {
     name: 'boolean-expression-modal',
     components: {
         BaseModal
     },
     props: {
         expression: {
             type: Object,
             default: null
         },
         target: {
             type: Object,
             default: null
         }
     },
     data () {
         return {
             availableFields: [],
             fields: {},
             model: {
                 expression_type: null
             },
             dataTypeList: [],
             hasErrors: false
         };
     },
     
     created () {
         this.fetchFields();
         if (this.expression) {
             this.model = _.cloneDeep(this.expression);
         }
         
         
         if (this.model.id == null) {
             this.model.id = this.randomId();
         }
         
         if (this.currentOp &&
             this.currentOp.arity == 'n' &&
             _.isArray(this.model.values) &&
             !this.valuesOptions) {
             this.model.values = _.join(this.model.values, ', ');
         }
         
     },
     computed: {
         expressionTypeOptions: function () {
             if (!this.expression ||
                 this.expression.expression_type == 'rule' ||
                 this.expression.expression_type == 'not'
             ) {
                 return [
                     {id: 'rule', value: 'rule', label: 'Rule'},
                     {id: 'and', value: 'and', label: 'And'},
                     {id: 'or', value: 'or', label: 'Or'},
                 ];
           } else {
               return [
                   {id: 'and', value: 'and', label: 'And'},
                   {id: 'or', value: 'or', label: 'Or'},
               ];
           }
         },
         opOptions: function () {
             if (this.currentField) {
                 return this.currentField.operators.map(function (e) {
                   return {
                       id: e.key,
                       value: e.key,
                       label: e.label
                   };
                 });
             }
             return [];
         },
         fieldOptions: function () {
             return this.availableFields.map(function (e) {
                 return {
                     id: e.id,
                     value: e.id,
                     label: e.name
                 };
             });           
         },
         fieldsDb: function () {
             let res = {}

             this.availableFields.forEach((f) => {
                 res[f.id] = f;
             });

             return res;
         },
         opsDb: function () {
             if (this.currentField) {
                 let res = {};
                 this.currentField.operators.forEach((op) => {
                     res[op.key] = op;
                 });
                 return res;
             }
             return null;
         },
         currentField: function () {
             if (this.model.field) {
                 return this.fieldsDb[this.model.field];
             }
             return null;
         },
         currentOp: function () {
             if (this.currentField && this.model.operator) {
                 return this.opsDb[this.model.operator];
             }
             return null;
         },
         valuesOptions: function () {
             if (this.model && this.model.field) {
                 return this.model.field.allowed_values;
             }
             return null;
         }
     },
     methods: {
         validation(ev) {
             this.hasErrors = ev.hasErrors;
         },
         randomId() {
             var r1 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
             var r2 = ("0000000" + (Math.random() * 10000000).toFixed()).substr(-7);
             return "temp_" + r1 + "_" + r2;
         },
         async fetchFields() {
             var self = this;
             var response = await API.fields.getList();
             this.availableFields = response.data;
         },
         close() {
             this.$emit('close');
         },
         deleteExpression() {
             this.$emit('save', null);
         },
         save() {
             if (this.hasErrors) {
                 return;
             }
             if (['and', 'or'].includes(this.model.expression_type)) {
                 this.model.operands = this.model.operands || [];
                 if (this.expression && this.expression.expression_type == 'rule') {
                     let operand = _.cloneDeep(this.expression);
                     delete operand['id'];
                     delete this.model.field;
                     delete this.model.operator;
                     delete this.model.field_label;
                     delete this.model.operator_label;
                     delete this.model.rendered_values;
                     
                     this.model.operands.push(operand);
                 }
             } 
             else {
                 if (this.currentOp) {
                     if (this.currentOp.arity == 1) {
                         this.model.values = null;
                         this.model.rendered_values = '';
                     }
                     else if (this.currentOp.arity == 'n') {
                         if (!_.isArray(this.model.values)) {
                             this.model.values = _.map(_.split(this.model.values, ','), _.trim);
                         }
                         this.model.rendered_values = _.join(this.model.values.slice(0,2), ', ');
                         if (this.model.values.length > 2) {
                             this.model.rendered_values = this.model.rendered_values + ', ...';
                         }
                     }
                     else {
                         this.model.rendered_values = this.model.values;
                     }
                     this.model.field_label = this.currentField.name;
                     this.model.operator_label = this.currentOp.label;
                 }
             }
             this.$emit('save', this.model);
         }
     }
 }
</script>


<style lang="scss">
.multiple-choices > div.formulate-input-group {
  height: 200px;
  max-height: 200px;
  overflow: auto;
  overscroll-behavior: contain;
  border: 1px solid #ddd;
  padding: 10px 10px;
  border-radius: 4px 4px 4px 4px;
}
</style>



// WEBPACK FOOTER //
// BooleanExpressionModal.vue?503fe3c4